import { Route, Routes } from "react-router-dom";
import { IndexPage } from "./pages/Index";
import { YellowDetailsPage } from "./pages/YellowDetails";
export function HRConfigManagement() {
    return (
        <Routes>
            <Route index element={<IndexPage />} />
            <Route index path = "/yellow-employee-details" element={<YellowDetailsPage />} />
        </Routes>
    );
}
